import { createContext } from 'react';

// OL
import OlMap from 'ol/Map';
import OlSourceVector from 'ol/source/Vector';
import OlPoint from 'ol/geom/Point';
import OlFeature from "ol/Feature";
import OlLineString from 'ol/geom/LineString';

// Types
import { RouteData, RoutePoint } from '@/components/MapRouting/useRouting';

export type MapRoutingContexType = {
  routeData: RouteData | null
  setRouteData: (rd: RouteData | null) => void,
  routingPoints: RoutePoint[],
  setRoutingPoints: (rp: RoutePoint[]) => void,
  addLayersToMap: (map: OlMap) => void;

  clickPointsSourceRef: React.MutableRefObject<OlSourceVector<OlFeature<OlPoint>>>
  routePointsSourceRef: React.MutableRefObject<OlSourceVector<OlFeature<OlPoint>>>
  routeSourceRef: React.MutableRefObject<OlSourceVector<OlFeature<OlLineString>>>
  clickPoint2routePointSourceRef: React.MutableRefObject<OlSourceVector<OlFeature<OlLineString>>>
  pointOnRouteSourceRef: React.MutableRefObject<OlSourceVector<OlFeature<OlPoint>>>
}

const MapRoutingContext = createContext<MapRoutingContexType | undefined>(undefined);

MapRoutingContext.displayName = 'MapRoutingContext';
export default MapRoutingContext;
